import { useEffect } from 'react';
import { buildCellClassRules, buildValueGetter } from './dynamicValueHelpers.js';

export default function useDynamicValueGetters(column, columnImportConfig, gridRef){
  const gridApi = gridRef?.current?.api;

  const setValueGetter = () => {
    if (gridApi){
      let colDefs = gridApi.getGridOption('columnDefs');
      colDefs.forEach(colDef => {
        if(colDef.field == column.accessor) { // Selected column
          colDef.valueGetter = buildValueGetter(column, columnImportConfig);
          colDef.cellClassRules = buildCellClassRules(column, columnImportConfig)
        }
      })
      gridApi.setGridOption('columnDefs', colDefs)
    }
  } 
  
  // When column config change.
  useEffect(() => {
    setValueGetter();
  }, [columnImportConfig])

}